import { render, staticRenderFns } from "./AcoesItem.vue?vue&type=template&id=154645f6"
import script from "./AcoesItem.vue?vue&type=script&lang=js"
export * from "./AcoesItem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports